import React from 'react'
import SubTitle from '../../../ui/SubTitle'
import VariantBox from './VariantBox'
import { VariantCategory } from '../../../../types/modules/product.type'

type Props={
  variant:VariantCategory
}

function ProductVariantListItem({variant}:Props) {
  return (
    <div>
        <div className='flex justify-between items-center'>
            <SubTitle title={variant.languages[0].name}/>
        </div>
        <div>
            {
              variant.variants.map(variantItem=>{
                return <VariantBox key={variantItem.id+"k"} categoryId={variant.id} variantItem={variantItem} 
                isColor={variant.languages.find(v=>v.name.toLowerCase()==="color" || v.name==="اللون")?true:false}/>
              })
            }
        </div>
    </div>
  )
}

export default ProductVariantListItem